/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */

/**
 * @module bookmark/bookmark
 */

import { Plugin, type PluginDependenciesOf } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import { BookmarkUI } from './bookmarkui.js';
import { BookmarkEditing } from './bookmarkediting.js';

/**
 * The bookmark feature.
 *
 * For a detailed overview, check the {@glink features/bookmarks Bookmarks} feature guide.
 */
export class Bookmark extends Plugin {
	/**
	 * @inheritDoc
	 */
	public static get pluginName() {
		return 'Bookmark' as const;
	}

	/**
	 * @inheritDoc
	 */
	public static get requires(): PluginDependenciesOf<[ BookmarkEditing, BookmarkUI, Widget ]> {
		return [ BookmarkEditing, BookmarkUI, Widget ];
	}

	/**
	 * @inheritDoc
	 */
	public static override get isOfficialPlugin(): true {
		return true;
	}
}
